import { createContext } from 'react'

import { ILike } from '../constants/types/common.types'

const LikeContext = createContext({
  status: {
    like: false,
    likeCount: '',
  },
} as {
  status: ILike
  setStatus: (status: ILike) => void
})

export default LikeContext
